/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { UserDtoModel, UserDtoModelType } from "./UserDtoModel"
import { UserDtoModelSelector } from "./UserDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  dispatchers: IObservableArray<UserDtoModelType>;
}

/**
 * SupportOrganizationDtoBase
 * auto generated base class for the model SupportOrganizationDtoModel.
 */
export const SupportOrganizationDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('SupportOrganizationDto')
  .props({
    __typename: types.optional(types.literal("SupportOrganizationDto"), "SupportOrganizationDto"),
    uuid: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.null, types.string),
    dispatchers: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => UserDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class SupportOrganizationDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
  dispatchers(builder: string | UserDtoModelSelector | ((selector: UserDtoModelSelector) => UserDtoModelSelector) | undefined) { return this.__child(`dispatchers`, UserDtoModelSelector, builder) }
}
export function selectFromSupportOrganizationDto() {
  return new SupportOrganizationDtoModelSelector()
}

export const supportOrganizationDtoModelPrimitives = selectFromSupportOrganizationDto().uuid.name
